<template>
  <div class="div">
    <div class="div-top">
      <el-input
        placeholder="请输入设备编号/名称"
        style="width: 250px"
        v-model="searchData.DeviceName"
        clearable
      ></el-input>
      <SelectData
        style="width: 250px; margin-left: 10px"
        v-model="searchData.DocumentType"
        :multiple="false"
        url="/Base_DeviceTreeManage/DeviceItem/GetDeviceDocumentTypeList"
        :option="{ label: 'DicName', Id: 'DicKey' }"
        :data="{}"
        placeholder="请选择文件类型"
      ></SelectData>

      <el-input
        placeholder="请输入文件名称"
        style="width: 250px; margin-left: 10px"
        v-model="searchData.DocumentName"
        clearable
      ></el-input>
      <el-button
        type="primary"
        style="width: 60px; margin-left: 10px"
        @click="search"
        >查询</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        style="width: 100%"
        size="mini"
        height="calc(100%)"
        v-loading="loading"
      >
        <el-table-column
          type="index"
          label="序号"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="device_no"
          label="设备编号"
          align="center"
          sortable
        ></el-table-column>
        <el-table-column
          prop="device_name"
          label="设备名称"
          align="center"
          sortable
        ></el-table-column>
        <el-table-column
          prop="specification"
          label="设备规格"
          align="center"
          sortable
        ></el-table-column>
        <el-table-column
          prop="InstallationAreaName"
          label="安装位置"
          align="center"
          sortable
        ></el-table-column>
        <el-table-column
          prop="DocumentTypeName"
          label="文件类型"
          align="center"
          sortable
        ></el-table-column>

        <el-table-column label="文件名称" width="400px" sortable>
          <!-- <template slot-scope="scope">
                  {{ JSON.parse(scope.row.DocumentJson).name }}
                </template> -->
          <template slot-scope="scope">
            <a
              :href="scope.row.ServerPath"
              target="_blank"
              style="color: #409eff"
              >{{ scope.row.DocumentName }}</a
            >
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="DocumentSize"
          label="文件大小"
          width="130px"
          sortable
        >
          <template slot-scope="scope">
            {{ tools.setSize(scope.row['DocumentSize']) }}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="CreateTime"
          label="移交日期"
          width="150px"
          sortable
        >
          <template slot-scope="scope">
            {{ moment(scope.row.CreateTime).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click.stop="download(scope.row)"
              icon="el-icon-download"
              style="margin-left: 10px; font-size: 14px"
              >下载</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div
      style="
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: right;
      "
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.PageIndex"
        :page-sizes="pagination.PageSizes"
        :page-size="pagination.PageRows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import tools from '@/utils/tools.js'
import SelectData from '@/components/SelectData/SelectData'
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      tools,
      moment,
      loading: false,
      searchData: {
        DeviceName: '',
        DocumentType: '',
        DocumentName: '',
      },
      DeviceTypeList: [],
      pagination: {
        PageIndex: 1,
        PageSizes: [20, 40, 60, 100],
        PageRows: 20,
        total: 0,
      },
      tableData: [],
      SupplierData: [],
    }
  },
  props: {
    isTime: {
      type: Boolean,
      default: false,
    },
  },
  components: { SelectData },
  methods: {
    search() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    download(row) {
      const loading = this.$loading({
        lock: true,
        text: '下载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const elink = document.createElement('a')
      elink.download = row.DocumentName
      elink.style.display = 'none'
      elink.target = '_blank'
      elink.href = row.ServerPath
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
      loading.close()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },

    getDataList() {
      this.loading = true
      this.$http
        .post(
          '/Base_DeviceTreeManage/DeviceItem/GetDeviceDocumentationDirectoryList',
          {
            PageIndex: this.pagination.PageIndex,
            PageRows: this.pagination.PageRows,
            DeviceType: !this.isTime ? this.devTreeSearch.DeviceType || '' : '',
            BuildingId: !this.isTime ? this.devTreeSearch.BuildingId || '' : '',
            InstallationArea: !this.isTime
              ? this.devTreeSearch.InstallationArea || ''
              : '',
            TreeType: !this.isTime ? this.devTreeSearch.TreeType || 0 : 0,
            ...this.searchData,
          }
        )
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['devTreeSearch']),
  },
  watch: {
    // {
    //           Condition: 'DeviceType',
    //           Keyword: this.devTreeSearch.DeviceType || '',
    //         },
    //         {
    //           Condition: 'BuildingId',
    //           Keyword: this.devTreeSearch.BuildingId || '',
    //         },
    //         {
    //           Condition: 'InstallationArea',
    //           Keyword: this.devTreeSearch.InstallationArea || '',
    //         },
    devTreeSearch() {
      this.getDataList()
    },
  },
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
// .FileInfo {
//   width: 100%;
//   height: 100%;
//   overflow-y: auto;
// }
.div-top {
  margin-bottom: 10px;
  height: 40px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 90px);
}
</style>
